import React, { useEffect, useRef, useState } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import i18n from "../../../../i18nextInitiator";
import { Button, Typography } from "@material-ui/core";
import { ArrowBackIos } from "@material-ui/icons";
import {
  selectService,
  submitPreOrder,
  formatTime,
  paths,
  setShowTimeCard,
  hasHeavyItem,
} from "../../../../actions/actionCreators";
import ButtonWithLoading from "../../ButtonWithLoading";
import SlideCard from "../../SlideCard";
import TimePicker from "../../TimePicker/TimePicker";
import { store } from "../../../../store";
import { push } from "connected-react-router";
import AreaSelector from "../AreaSelector";
import SelectFloor from "../SelectFloor";
import Divider from "../../Divider";
import HeavyItems from "../HeavyItems";
import StopTime from "../StopTime";
import WorkerSelector from "../WorkerSelector";
import { getButtonsItemsPrice } from "../../../../actions/apiCallActions";
import ButtonWithLoadingCustom from "../../ButtonWithLoadingCustom";

const t = i18n.getFixedT("fa", "general");

const useStyles = makeStyles((theme) => ({
  root: {
    padding: "20px 20px",
    paddingBottom: "120px",
    maxWidth: 600,
    margin: "0 auto",
    "& > *": {
      margin: ".8rem 0",
    },
    "& button": {
      boxShadow: "unset",
    },
    "& *:focus": {
      outline: 0,
    },
  },
  paper: {
    backgroundColor: theme.palette.primary.light,
    borderRadius: ".3rem",
    border: `solid 1px ${theme.palette.primary.border}`,
    padding: ".5rem",
    width: "100%",
    zIndex: 1,
    boxShadow: "none",
    minHeight: "4rem",
  },
  tabSelected: {
    color: "white",
  },
  tabIndicator: {
    height: "100%",
    zIndex: -1,
    borderRadius: 8,
    // boxShadow: `0 0 5px 2px rgba(25, 39, 131, 0.24)`
  },
  serviceSubtitle: {
    fontWeight: 900,
  },
  box: {
    margin: ".3rem 0",
  },
  bottomBoxRoot: {
    position: "fixed",
    bottom: 0,
    left: 0,
    right: 0,
    top: "auto",
    zIndex: "100",
    backgroundColor: "#fff",
    width: "100%",
    maxWidth: 600,
    margin: "0 auto",
    maxHeight: 200,
    boxShadow: "0px 0px 20px 0 rgb(0 0 0 / 20%)",
    borderRadius: "8px 8px 0 0",
  },
  bottomBox: {
    padding: "10px 20px",
    "& > *": {
      margin: ".5rem 0",
    },
    display: "flex",
    flexWrap: "nowrap",
  },
}));

const mapStateToProps = (state) => ({ ...state.order });

/**
 * Order Page
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const Index = (props) => {
  const classes = useStyles();

  const {
    locatingDone,

    order: { vasayeleHazinedar: heavyItems = [], car_id } = {},
  } = props;
  const buttonsPrice = store.getState().order.priceButtons;
  const { startAddressLat: lat, startAddressLong: long } =
    store.getState().order.order;
  useEffect(() => {
    if (lat && long) {
      getButtonsItemsPrice({ lat, long });
    }
  }, [lat, long]);

  const [services, setServices] = useState([2, 1, 3]);
  const [showTime, setShowTime] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [confirmNoHeavyItem, setConfirmNoHeavyIem] = useState(false);
  const heavyItemRef = useRef(null);

  useEffect(() => {
    console.log(heavyItems);
    if (!locatingDone) store.dispatch(push(paths.map));
  }, []);
  const [selectServiceNew, setSelectServiceNew] = useState(2);

  const handleChange = (event, newValue) => {
    selectService(newValue);
    setSelectServiceNew(newValue);
  };

  /**
   * Display the Time Picker Slide Card.
   */
  const displayTime = () => {
    if (!showTime) setShowTimeCard(true);
  };

  const handleNoHeavyItem = () => {
    heavyItemRef.current.scrollIntoView({
      behavior: "smooth",
      block: "center",
    });
    setShowAlert(true);
  };

  const onSubmit = () => {
    !hasHeavyItem() && !confirmNoHeavyItem
      ? handleNoHeavyItem()
      : submitPreOrder();
  };

  return (
    <>
      <Grid container className={classes.root}>
        <Paper className={classes.paper}>
          <Tabs
            value={car_id}
            onChange={handleChange}
            variant="fullWidth"
            indicatorColor="primary"
            classes={{ indicator: classes.tabIndicator }}
          >
            {services.map((number, index) => {
              return (
                <Tab
                  value={number}
                  classes={{ selected: classes.tabSelected }}
                  key={number}
                  label={
                    <>
                      <Typography>{t(`services.${index}.title`)}</Typography>
                      <Typography className={classes.serviceSubtitle}>
                        {t(`services.${index}.subtitle`)}
                      </Typography>
                    </>
                  }
                />
              );
            })}
          </Tabs>
        </Paper>
        <Grid ref={heavyItemRef} xs={12} container>
          <HeavyItems
            showAlert={showAlert}
            confirm={confirmNoHeavyItem}
            onConfirmChange={() => setConfirmNoHeavyIem(!confirmNoHeavyItem)}
          />
        </Grid>

        <Divider />

        <WorkerSelector selectService={selectServiceNew} />

        <SelectFloor />

        <Divider />

        <Button className={classes.paper} onClick={displayTime}>
          <Grid xs={12} item>
            <Grid justifyContent={"space-between"} container>
              <Grid item>
                <Typography>{t("time.picker-title")}</Typography>
              </Grid>
              <Grid item>
                <Typography>
                  {t("select")}
                  <ArrowBackIos />
                </Typography>
              </Grid>
            </Grid>
            {props.order.time && (
              <Grid container>
                <Typography component={"span"} variant={"subtitle2"}>
                  {formatTime(props.order.time)}
                </Typography>
              </Grid>
            )}
          </Grid>
        </Button>

        <Divider />

        <AreaSelector />

        <StopTime />
      </Grid>

      <SlideCard
        show={props.showTimeCard}
        title={t("time.picker-title")}
        close={() => setShowTimeCard(false)}
      >
        <TimePicker close={() => setShowTimeCard(false)} />
      </SlideCard>
      <div className={classes.bottomBoxRoot}>
        <Grid container className={classes.bottomBox}>
          {buttonsPrice.length ? (
            buttonsPrice.map((item, index = 0) => {
              return (
                <ButtonWithLoadingCustom
                  text={item.name}
                  action={onSubmit}
                  loading={props.preOrdering}
                  key={index}
                  id={item.id}
                  tooltip={item.description}
                  buttonsPriceCount={buttonsPrice.length}
                />
              );
            })
          ) : (
          <ButtonWithLoading
            text={t("see-final-price")}
            action={onSubmit}
            loading={props.preOrdering}
          />
          )}
        </Grid>
      </div>
    </>
  );
};
export default withRouter(connect(mapStateToProps)(Index));
